import { Link } from 'react-router-dom'
import { useState } from 'react'

export default function NewsletterSection() {
  const [email, setEmail] = useState('')
  const [status, setStatus] = useState<'idle' | 'loading' | 'success' | 'error'>('idle')
  const [statusMsg, setStatusMsg] = useState('')

  const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault()
    const form = e.currentTarget
    const formData = new FormData(form)
    const honeypot = (formData.get('phone_alt') as string || '').trim()
    if (honeypot) {
      setStatus('success')
      setStatusMsg('订阅成功！感谢您的关注。')
      return
    }
    setStatus('loading')
    try {
      const resp = await fetch('https://readdy.ai/api/form/d9sv9a58o1vn02ekumj0', {
        method: 'POST',
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
        body: new URLSearchParams({ email: formData.get('email') as string }).toString(),
      })
      const text = await resp.text()
      let parsed: any = {}
      try { parsed = JSON.parse(text) } catch { /* parse failed, use empty object */ }
      if (resp.ok && parsed?.code === 'OK') {
        setStatus('success')
        setStatusMsg('订阅成功！感谢您的关注。')
        setEmail('')
      } else {
        const msg = parsed?.meta?.message || parsed?.message || '订阅失败，请稍后再试。'
        setStatus('error')
        setStatusMsg(msg)
      }
    } catch {
      setStatus('error')
      setStatusMsg('网络错误，请检查连接后重试。')
      void 0
    }
  }

  return (
    <section className="py-16 md:py-20 bg-background-50">
      <div className="max-w-[1400px] mx-auto px-4 md:px-6">
        <div className="bg-primary-500 rounded-2xl p-10 md:p-14 text-center relative overflow-hidden">
          <div className="absolute inset-0 opacity-10">
            <div className="absolute -top-10 -right-10 w-64 h-64 rounded-full bg-background-50"></div>
            <div className="absolute -bottom-10 -left-10 w-48 h-48 rounded-full bg-background-50"></div>
          </div>
          <div className="relative z-10">
            <h2 className="text-2xl md:text-3xl font-heading font-bold text-background-50 mb-4">
              订阅我们的资讯推送
            </h2>
            <p className="text-background-50/80 max-w-lg mx-auto mb-8 leading-relaxed">
              第一时间获取最新色里番推荐、深度评测和行业动态，不错过任何精彩内容。
            </p>
            <form
              onSubmit={handleSubmit}
              data-readdy-form
              className="flex flex-col sm:flex-row items-center justify-center gap-3 max-w-md mx-auto"
            >
              <input
                type="text"
                name="phone_alt"
                tabIndex={-1}
                autoComplete="off"
                aria-hidden="true"
                readOnly
                className="honeypot-field"
              />
              <input
                type="email"
                name="email"
                placeholder="输入您的邮箱地址"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                className="w-full sm:flex-1 px-5 py-3 rounded-full bg-background-50 text-foreground-950 text-sm placeholder:text-foreground-400 focus:outline-none focus:ring-2 focus:ring-background-50/50"
                required
              />
              <button
                type="submit"
                disabled={status === 'loading'}
                className="w-full sm:w-auto px-8 py-3 rounded-full bg-background-950 text-background-50 font-medium text-sm hover:bg-background-900 transition-all duration-300 whitespace-nowrap cursor-pointer disabled:opacity-60"
              >
                {status === 'loading' ? '提交中...' : '立即订阅'}
              </button>
            </form>
            {status === 'success' && (
              <p className="mt-4 text-background-50/90 text-sm">{statusMsg}</p>
            )}
            {status === 'error' && (
              <p className="mt-4 text-background-50/90 text-sm">{statusMsg}</p>
            )}
          </div>
        </div>
      </div>
    </section>
  )
}